import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import { Button, IconButton, Tooltip } from '@mui/material';
import { FormattedMessage } from 'react-intl';

type FormActionsMuiDiscardActionProps = {
  isCompact: boolean;
  disabled: boolean;
  onDiscard: () => void;
};

/** Discard action as a text button or compact icon button. */
export function FormActionsMuiDiscardAction({
  isCompact,
  disabled,
  onDiscard,
}: FormActionsMuiDiscardActionProps) {
  if (isCompact) {
    return (
      <Tooltip title={<FormattedMessage id="common.actions.discard" defaultMessage="Descartar" />}>
        <span>
          <IconButton color="secondary" onClick={onDiscard} disabled={disabled} size="small">
            <DeleteOutlinedIcon />
          </IconButton>
        </span>
      </Tooltip>
    );
  }

  return (
    <Button
      color="secondary"
      startIcon={<DeleteOutlinedIcon />}
      onClick={onDiscard}
      disabled={disabled}
    >
      <FormattedMessage id="common.actions.discard" defaultMessage="Descartar" />
    </Button>
  );
}
